import React, { useEffect, useRef } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { LICENCE_KEY } from "../constants/charts";

am4core.addLicense(LICENCE_KEY);

export default function AmBarChart({
  id,
  title,
  data,
  chartColor = "orange",
  horizontal = false,   // 🔥 NEW PARAM
  clickFunction
}) {

  const chartRef = useRef(null);

  useEffect(() => {

    const chart = am4core.create(id, am4charts.XYChart);
    chart.data = data;

    let categoryAxis;
    let valueAxis;

    // ================= AXES =================

    if (horizontal) {
      // 🔥 HORIZONTAL MODE

      categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "category";
      categoryAxis.renderer.inversed = true; // 🔥 highest at top
      categoryAxis.renderer.grid.template.disabled = true;
      categoryAxis.renderer.labels.template.fill = am4core.color("#666");
      categoryAxis.renderer.labels.template.fontSize = 10;
      categoryAxis.renderer.minGridDistance = 10;

      valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.grid.template.strokeOpacity = 0.05;
      valueAxis.renderer.labels.template.fill = am4core.color("#666");
      valueAxis.renderer.labels.template.fontSize = 10;

    } else {
      // 🔥 VERTICAL MODE (existing)

      categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "category";
      categoryAxis.renderer.grid.template.disabled = true;
      categoryAxis.renderer.labels.template.fill = am4core.color("#666");
      categoryAxis.renderer.labels.template.fontSize = 10;
      categoryAxis.renderer.minGridDistance = 10;

      valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.grid.template.strokeOpacity = 0.05;
      valueAxis.renderer.labels.template.fill = am4core.color("#666");
      valueAxis.renderer.labels.template.fontSize = 10;
    }

    // ================= SERIES =================

    const series = chart.series.push(new am4charts.ColumnSeries());

    if (horizontal) {
      series.dataFields.valueX = "value";
      series.dataFields.categoryY = "category";
    } else {
      series.dataFields.valueY = "value";
      series.dataFields.categoryX = "category";
    }

    // ================= STYLING =================

    const softenedColor = am4core.color(chartColor);
    softenedColor.alpha = 0.85;

    series.columns.template.fill = softenedColor;
    series.columns.template.strokeWidth = 0;

    if (!horizontal) {
      // vertical rounded tops
      series.columns.template.cornerRadiusTopLeft = 4;
      series.columns.template.cornerRadiusTopRight = 4;
    } else {
      // horizontal rounded ends
      series.columns.template.cornerRadiusTopRight = 4;
      series.columns.template.cornerRadiusBottomRight = 4;
    }

    series.columns.template.adapter.add("fill", function(fill, target) {
      return am4core.color(chartColor);
    });

    // Hover
    series.columns.template.states.create("hover").properties.fillOpacity = 0.8;
	
	series.columns.template.events.on("hit", function(ev) {
	  const category = ev.target.dataItem.categoryX;
		if(clickFunction){
			clickFunction(category);
		}
	});
	
	// ================= TOOLTIP =================

	if (horizontal) {

	    series.columns.template.tooltipText =
	        "{category}: [bold]{valueX}[/]";

	}
	else {

	    series.columns.template.tooltipText =
	        "{category}: [bold]{valueY}[/]";

	}

	series.tooltip.getFillFromObject = false;

	series.tooltip.background.fill =
	    am4core.color("#111");

	series.tooltip.label.fill =
	    am4core.color("#fff");

	series.tooltip.background.cornerRadius = 6;

	series.tooltip.background.strokeOpacity = 0;

    // Axis titles (optional)
    categoryAxis.title.fontSize = 10;
    valueAxis.title.fontSize = 10;

    chartRef.current = chart;

    return () => {
      chart.dispose();
    };

  }, [id, data, chartColor, horizontal]); // 🔥 include horizontal

  return (
    <div id={id} style={{ width: "100%", height: "100%" }}></div>
  );
}